import { format, getMonth, getYear, isSameMonth } from "date-fns";
import type { FC } from "react";
import { MONTH_LABEL_FORMAT } from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { FlatRowDatePanelCell } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelCell";
import { isMonthWithinBounds } from "web_myplann/Shared/Components/FlatRow/isMonthWithinBounds";
import { useDateFnsLocale } from "web_myplann/Shared/Hooks/useDateFnsLocale";

type Props = {
	months: Date[];
	value: Date | null;
	minDate?: Date;
	maxDate?: Date;
	onSelect: (month: Date) => void;
};

export const FlatRowDateMonthList: FC<Props> = ({
	months,
	value,
	minDate,
	maxDate,
	onSelect,
}) => {
	const locale = useDateFnsLocale();

	return (
		<>
			{months.map((month) => (
				<FlatRowDatePanelCell
					key={month.getTime()}
					label={format(month, MONTH_LABEL_FORMAT, { locale })}
					selected={value !== null && isSameMonth(month, value)}
					disabled={
						!isMonthWithinBounds(
							getYear(month),
							getMonth(month),
							minDate,
							maxDate,
						)
					}
					onClick={() => onSelect(month)}
				/>
			))}
		</>
	);
};
